export default "__VITE_ASSET__54d544f3__"